var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingGraphicLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 84,
    viewBox: "0 0 44 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7138 45.0366C21.7973 43.9924 20.053 42.6952 18.5737 41.1713C18.0941 40.7342 18.7963 40.0279 19.2759 40.4651C20.7552 41.9889 22.4328 43.1667 24.2561 44.1847C24.762 44.5287 24.3128 45.407 23.7138 45.0366Z",
    fill: "#030047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1172 73.2032L13.7596 76.9738C13.7596 76.9738 16.7348 83.0779 21.9962 81.3758C27.2577 79.6736 27.1172 73.2032 27.1172 73.2032Z",
    fill: "#ffbb00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6106 46.8864C36.6106 48.4357 35.3547 49.6917 33.8053 49.6917C32.256 49.6917 31 48.4357 31 46.8864C31 45.337 32.256 44.0811 33.8053 44.0811C35.3547 44.0811 36.6106 45.337 36.6106 46.8864Z",
    fill: "#ffbb00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3833 38.8477C39.5103 38.8477 43.7666 34.688 43.7666 29.4643C43.7666 24.2406 39.607 20.0811 34.3833 20.0811C29.1596 20.0811 25 24.2406 25 29.4643C25 34.688 27.9988 38.8477 34.3833 38.8477Z",
    fill: "#ffbb00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82477 58.3957L0 51.7686L6.62711 43.9438L14.4519 50.5709L7.82477 58.3957Z",
    fill: "#030047"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.416 11.082L5 15.7253L11.8682 21.7229L13.416 11.082Z",
    fill: "#030047"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9403 8.59119C33.9403 8.39772 33.8436 8.30098 33.7469 8.10751L27.4591 0.271964C27.1689 -0.0182417 26.7819 -0.114983 26.395 0.175223C26.1048 0.465428 26.0081 0.852374 26.2983 1.23931L32.5861 9.07487C32.8763 9.36507 33.2632 9.4618 33.6501 9.17159C33.8436 8.97812 33.9403 8.78466 33.9403 8.59119Z",
    fill: "#030047"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01552 31.5181L8.01552 31.4214C7.91878 31.0345 7.53184 30.7443 7.1449 30.841L2.30814 31.7116C1.9212 31.8084 1.631 32.1953 1.72773 32.5822C1.82447 32.9692 2.21141 33.2594 2.59835 33.1627L7.4351 32.292C7.72531 32.1953 8.01552 31.9051 8.01552 31.5181Z",
    fill: "#030047"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.774 61.6986C41.774 61.4084 41.5805 61.1182 41.2903 61.0215L31.1331 57.1521C30.7462 57.0553 30.3592 57.1521 30.1658 57.539C30.069 57.926 30.1657 58.3129 30.5527 58.5064L40.7099 62.3758C41.0968 62.4725 41.4838 62.3758 41.6772 61.9888C41.774 61.8921 41.774 61.7954 41.774 61.6986Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingGraphicLeft);
export default __webpack_public_path__ + "static/media/onboarding-graphic-left.b2b5b6d631155e55b57e972567032f87.svg";
export { ForwardRef as ReactComponent };